<template>
  <component v-bind:is="elName" v-bind="elData"></component>
</template>

<script>
export default {
  name: "ComponentWrapper",

  props: {
    elName: {
      type: String,
      required: true
    },
    elData: {
      type: Object,
      required: true
    },
    elOpts: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  mounted() {
    // setInterval(() => {
    //   this.$root.$emit("test");
    // }, 2000);
  }
};
</script>

<style lang="scss">
body {
  background: $gray100;
}

#app {
  padding: blh(2);

  @include bpXs {
    padding: blh(0.5);
  }
}

.ewc-project-inventory,
.ewc-project-documents,
.ewc-project-contact-form {
  width: 650px;
  max-width: 100%;
  margin-bottom: blh(2);
}

// THEMES
// @import "./assets/scss/themes/fredericktrust";
</style>
